import { UploadSource } from '@buffer-mono/uploader'
import type { BufferUpload, Uploader } from '@buffer-mono/uploader'

/**
 * Uploads an Insights snapshot and resolves with the URL the upload service
 * stored it at.
 */
export async function uploadInsightsImage({
  uploader,
  file,
  sourceName,
}: {
  uploader: Pick<Uploader, 'on' | 'off' | 'upload'>
  file: File
  sourceName: string
}): Promise<string> {
  let url: string | undefined

  const handleUploadFinished = (upload: BufferUpload): void => {
    const { source } = upload.meta
    if (UploadSource.isOtherSource(source) && source.name === sourceName) {
      url = upload.url
    }
  }

  uploader.on('upload-finished', handleUploadFinished)
  try {
    await uploader.upload([file], {
      source: UploadSource.integration(sourceName),
    })
  } finally {
    uploader.off('upload-finished', handleUploadFinished)
  }

  if (!url) {
    throw new Error('The upload service reported no finished upload')
  }

  return url
}
